export const AUTH_USERNAME_STORAGE = "Login-username";
export const AUTH_USERPOOL_STORAGE = "Login-userpool";
export const AUTH_CLIENT_ID_STORAGE = "Login-client-id";
export const AUTH_COGNITO_DOMAIN_STORAGE = "Login-cognito-domain";
